import { render, staticRenderFns } from "./ComparisonDate.vue?vue&type=template&id=47f5d2c7"
import script from "./ComparisonDate.vue?vue&type=script&lang=ts"
export * from "./ComparisonDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports